import {getBackendUrl} from 'utilities';

import type {AutodraftAppKey} from './autodraftApps';

export type WorkstreamAutodraft = {
  workstream_id: number;
  setup_complete: boolean;
  connected_apps: AutodraftAppKey[] | null;
  instructions: string | null;
  generated_markdown: string | null;
  generated_status: string | null;
  generated_at: string | null;
  cycle_due_at: string | null;
};

async function parseError(res: Response): Promise<string> {
  let detail = res.statusText || 'Request failed';
  try {
    const j: unknown = await res.json();
    if (j && typeof j === 'object' && 'detail' in j) {
      detail = String((j as {detail?: unknown}).detail);
    }
  } catch {
    // ignore
  }
  return detail;
}

export async function fetchWorkstreamAutodraft(workstreamId: number): Promise<WorkstreamAutodraft> {
  const base = getBackendUrl().replace(/\/+$/, '');
  const res = await fetch(`${base}/api/v1/workstream/${workstreamId}/autodraft`, {
    method: 'GET',
    credentials: 'include',
    headers: {'Content-Type': 'application/json'},
  });
  if (!res.ok) {
    throw new Error(await parseError(res));
  }
  return (await res.json()) as WorkstreamAutodraft;
}
